import React, { useState, useEffect } from "react"
import styled from "styled-components"

import { Flex } from "components/box"
import { EyebrowSmall, PlainLink } from "components/text"

const Container = styled(Flex)`
  transition: ease-in 0.2s all;
  height: ${props => props.theme.space[6]};
`

const LinkContainer = styled(PlainLink)`
  text-decoration: none;
`

type PromotionBarProps = {
  text: string | React.ReactNode
  animated?: boolean
  animatedText?: string | React.ReactNode
  animatedBg?: string
  duration?: number
  href?: string
  coveBannerHref?: string
}

const PromotionBar: React.FC<PromotionBarProps> = ({
  text,
  animated,
  animatedText,
  duration,
  animatedBg,
  href,
  coveBannerHref
}) => {
  const [toggleBanner, setToggleBanner] = useState(false)
  const [hyperlink, setHyperlink] = useState<string | undefined>(coveBannerHref)
  useEffect(() => {
    if (animated) {
      const intervalId = setInterval(() => {
        setToggleBanner(state => !state)
        setHyperlink(hyperlink => (hyperlink === href ? coveBannerHref : href))
      }, duration || 5000)

      return () => clearInterval(intervalId)
    }

    return () => null
  }, [animated, duration, coveBannerHref])

  const bg = animatedBg ? (toggleBanner ? animatedBg : "paleAqua") : "paleAqua"
  const body = (
    <Container py={3} justifyContent="center" alignItems="center" textAlign="center" bg={bg}>
      {toggleBanner ? (
        animatedText
      ) : (
        <EyebrowSmall color="evergreen">{hyperlink ? <div css={"cursor:pointer;"}>{text}</div> : text}</EyebrowSmall>
      )}
    </Container>
  )

  return hyperlink ? <LinkContainer href={hyperlink}>{body}</LinkContainer> : body
}

export default PromotionBar
